import script from "./Subscribe.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subscribe.vue?vue&type=script&setup=true&lang=ts"

export default script